import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Header({ clsName = '', calcObj, onBack, i18n = 'calculators.mm100.progress.' }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('shared');
    const [headerBordered, setHeaderBordered] = useState(false);
    const widthCalc = calcObj.totalStep - 1;

    const lineMaskStyleMap: { [type: number]: React.CSSProperties } = {
        1: {
            width: '0',
        },
        2: {
            width: `calc(100% / ${widthCalc})`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% - 3px))',
        },
        3: {
            width: `calc(100% / ${widthCalc} * 2 + 2px)`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% / 2 - 1.5px))',
        },
        4: {
            width: `calc(100% / ${widthCalc} * 3)`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% / 3 - 1px))',
        },
        5: {
            width: `calc(100% / ${widthCalc} * 4 + 2px)`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% / 4 - 0.8px))',
        },
        6: {
            width: `calc(100% / ${widthCalc} * 5 + 6px)`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% / 5 - 1px))',
        },
        7: {
            width: `calc(100% / ${widthCalc} * 6 + 8px)`,
            background: 'repeating-linear-gradient(120deg, #FFF, #FFF 3px, #165DFF 0, #165DFF calc(100% / 6 - 1px))',
        },
    };

    useEffect(() => {
        if (window) {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const handleScroll = () => {
        const htmlEl = document?.querySelector('html') as HTMLElement;
        if (htmlEl) {
            setHeaderBordered(htmlEl.scrollTop > 0);
        }
    };

    const renderStep = (data: any) => {
        const { totalStep, currentStep, stepTitle } = data;
        const stepList = [];

        for (let index = 1; index < totalStep; index++) {
            if (index === 1) {
                stepList.push(
                    <td className="step first-step" key={index}>
                        <text className="text">{t(`${i18n}${stepTitle[index - 1]}`)}</text>
                        {index === currentStep && <div className="dot" />}
                    </td>,
                );
            } else if (index === totalStep - 1) {
                stepList.push(
                    <td className="step last-step" key={index}>
                        <div className="left">
                            <div className="step-panel">
                                {index === currentStep && <div className="dot" />}
                                <text className="text">{t(`${i18n}${stepTitle[index - 1]}`)}</text>
                            </div>
                        </div>
                        <div className="right">
                            {index + 1 === currentStep && <div className="dot" />}
                            <div className="text">{t(`${i18n}${stepTitle[index]}`)}</div>
                        </div>
                    </td>,
                );
            } else {
                stepList.push(
                    <td className="step" key={index}>
                        <div className="step-panel">
                            {index === currentStep && <div className="dot" />}
                            <text className="text">{t(`${i18n}${stepTitle[index - 1]}`)}</text>
                        </div>
                    </td>,
                );
            }
        }

        return stepList;
    };

    return (
        <div className={`calculator-header-${clsName} ${css.calculatorheader}`} style={{ borderBottom: headerBordered ? '1px solid #e9e9e9' : 0 }}>
            <div className="step-section">
                <div
                    className="line"
                    style={{
                        background: `repeating-linear-gradient(120deg, #FFF, #FFF 3px, #ededed 0, #ededed calc(100% / ${calcObj.totalStep - 1}))`,
                    }}
                />
                <div className="line-mask" style={{ ...lineMaskStyleMap[calcObj.currentStep] }}>
                    <div className="left-cover">
                        <span className="cover"></span>
                    </div>
                    {calcObj?.currentStep === calcObj?.stepTitle?.length && (
                        <div className="right-cover" style={{ right: calcObj?.stepTitle?.length === 7 ? '8px' : '6px' }}>
                            <span className="cover"></span>
                        </div>
                    )}
                </div>
                <table className="step-list">
                    <tbody>
                        <tr>{renderStep(calcObj)}</tr>
                    </tbody>
                </table>
            </div>
            {calcObj.currentStep !== 1 && (
                <div className="back" onClick={onBack}>
                    <div className="back-icon">{'<'}</div>
                    <div className="text">{t('calculators.mm100.back')}</div>
                </div>
            )}
        </div>
    );
}
